export default "__VITE_ASSET__d01ff55d__"